<template>
  <Button
    icon="eenvandaag-general:share-outline"
    label="Delen"
    variant="secondary"
    :analytics="analytics"
    @click="handleClick"
    @click.middle="handleClick"
    >copy</Button
  >
</template>

<script setup lang="ts">
import type { IAnalytics } from '~~/types/local_types';

const { $event } = useNuxtApp(); // Adjust path

interface IProps {
  url: string;
  analytics?: IAnalytics;
}

const props = defineProps<IProps>();

const handleClick = async () => {
  await navigator.clipboard.writeText(props.url);
  $event('snackbar:show', { message: 'Link gekopieërd' });
};
</script>

<style scoped lang="postcss"></style>
